import { BadgeType } from 'gql/autogen/BadgeType';
import { Badge } from 'gql/autogen/Badge';

export const getBookingCountForBadge = (bookingInfoBadges: Badge[]): number | null => {
    if (!bookingInfoBadges.length) return null;
    const bookingCountBadge = bookingInfoBadges.find((badge) => badge.badgeType === BadgeType.BOOKING_COUNT_ALL_TIME);
    if (!bookingCountBadge || !bookingCountBadge.enrichmentData || !bookingCountBadge.enrichmentData.length) {
        return null;
    }

    const bookingCount = Number(bookingCountBadge.enrichmentData[0]);
    if (!bookingCount || bookingCount < 20) return null;
    return bookingCount;
};
